/** @jsx jsx */
import type { HTMLAttributes } from 'react';
import React, { forwardRef } from 'react';
import { jsx } from '@balance-web/core';
import { Box } from '@balance-web/box';
import { theme } from '@balance-web/theme';

type RadioButtonGroupWrapperProps = {
  optionCount: number;
  size?: 'small' | 'medium';
} & HTMLAttributes<HTMLDivElement>;
export const Wrapper = forwardRef<HTMLDivElement, RadioButtonGroupWrapperProps>(
  ({ optionCount, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        css={{
          backgroundClip: 'padding-box',
          borderRadius: theme.radii.small,
          boxShadow: `0 0 0 1px ${theme.primitives.colour.primary.k40}`,
          boxSizing: 'border-box',
          cursor: 'pointer',
          display: 'grid',
          gridTemplateColumns: `repeat(${optionCount - 1}, 1fr 1px) 1fr`,
          fontSize: theme.typography.fontSize.small,
          fontWeight: theme.typography.fontWeight.medium,
          // Fixed height as per designs.
          height: props.size === 'small' ? 31 : 37,
          outline: 0,
          position: 'relative',
          '&:focus-within': {
            boxShadow: `0 0 0 2px ${theme.palette.global.focusRing}`,
          },
        }}
        {...props}
      />
    );
  }
);
Wrapper.displayName = 'RadioButtonGroupWrapper';
